import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4f0084cb&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=4f0084cb&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0084cb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f0084cb')) {
      api.createRecord('4f0084cb', component.options)
    } else {
      api.reload('4f0084cb', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4f0084cb&scoped=true", function () {
      api.rerender('4f0084cb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modulestore/module/7-3-pop-icon-1/index.vue"
export default component.exports